import React, { useState, useEffect } from 'react'
import { FaArrowUp } from 'react-icons/fa'

export const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className='fixed bottom-8 right-8 p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50'
          style={{
            backgroundColor: 'var(--accent-primary)',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
          }}
          aria-label='Scroll to top'
        >
          <FaArrowUp className='text-xl' />
        </button>
      )}
    </>
  )
}
